/**
 * Formats a full name to abbreviated format: "E. Sukunimi"
 * Team names (e.g., "Saksa 2") are not abbreviated.
 * @param fullName - Full name (e.g., "Iivo Niskanen") or team name (e.g., "Saksa 2")
 * @returns Abbreviated name (e.g., "I. Niskanen") or team name as-is
 */
export function formatName(fullName: string): string {
  const trimmed = fullName.trim();
  if (!trimmed) return ''; // Empty or only whitespace

  const parts = trimmed.split(' ').filter((part) => part.length > 0);
  if (parts.length === 1) return parts[0]; // Only one name

  // Check if it's a team name (e.g., "Saksa 2", "Italia 3")
  const lastPart = parts[parts.length - 1];
  if (/^\d+$/.test(lastPart)) {
    return trimmed; // Return team name as-is
  }

  const firstName = parts[0];
  const lastName = parts[parts.length - 1];
  return `${firstName.charAt(0)}. ${lastName}`;
}
